import Link from "next/link";

interface Props {
  items: { label: string; href?: string }[];
}
export function AdminBreadcrumb({ items }: Props) {
  return (
    <ol className="breadcrumb float-xl-end">
      {items.map((item, index) => (
        <li
          key={index}
          className={`breadcrumb-item ${
            index === items.length - 1 ? "active" : ""
          }`}
        >
          {item.href ? <Link href={item.href}>{item.label}</Link> : item.label}
        </li>
      ))}
    </ol>
  );
}
